import {
  CalendarIcon,
  ChartPieIcon,
  RectangleStackIcon,
  DocumentTextIcon,
  MapPinIcon,
  PhotoIcon,
  ShareIcon,
  TableCellsIcon,
  UsersIcon,
} from "@heroicons/react/24/outline"
import classNames from "classnames"
import { AssetIcon, CompanyIcon, DealIcon, PortfolioIcon } from "web/icons"

const iconMap = {
  asset: AssetIcon,
  calendar: CalendarIcon,
  chart: ChartPieIcon,
  deal: DealIcon,
  gallery: PhotoIcon,
  map: MapPinIcon,
  model: RectangleStackIcon,
  table: TableCellsIcon,
  text: DocumentTextIcon,
  company: CompanyIcon,
  partner: CompanyIcon,
  portfolio: PortfolioIcon,
  marketing: ShareIcon,
  users: UsersIcon,
}

export default function TileIcon({ icon, label }) {
  const Icon = iconMap[icon]

  const labelList = ["Company", "Portfolio", "Partner"]

  const classes = classNames("h-8 w-8 text-neutral-8", {
    "fill-neutral-8 group-hover:fill-primary-8": labelList.includes(label),
    "group-hover:text-primary-8": !labelList.includes(label),
  })

  return <Icon className={classes} />
}
